import { useState } from "react";
import { FaTaxi } from "react-icons/fa";
import { RiAdminFill } from "react-icons/ri";
import Navbar from "../NavBar";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full">
      {/* Top Bar */}
      <div className="hidden md:block lg:block bg-white border-b">
        <div className="container mx-auto px-4 py-3">
          <div className="flex flex-col lg:flex-row items-center gap-4">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img
                src="./assets/TAXICA_LOGO.png"
                alt="Taxica India Service"
                className="h-16 w-auto"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-4 lg:ml-auto">
              <button className="flex items-center gap-2 px-4 py-2 bg-yellow-400 text-gray-900 rounded-full hover:bg-yellow-500 transition-colors">
                <FaTaxi />
                <span className="font-medium hidden md:inline font-Poppins">
                  DRIVE WITH US
                </span>
              </button>

              <button className="px-4 py-2 bg-yellow-400 text-gray-900 rounded-full hover:bg-yellow-500 transition-colors">
                <span className="font-medium font-Poppins">BOOK A RIDE</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Sticky Navbar */}
      <div className="sticky top-0 z-50 bg-white shadow-md">
        <Navbar />
      </div>
    </header>
  );
}
